import CrudOfflineOnline from '@/views/crud/views/CrudOfflineOnline.vue';
import CrudOnlineOnly from '@/views/crud/views/CrudOnlineOnly.vue';

export default [
  {
    path: '/crud-offline-online/',
    component: CrudOfflineOnline,
    //component: () => import('@/views/crud/views/CrudOfflineOnline.vue'),
    meta: { 
      requiresPermission: 'crud_offline_online.view', 
      requiresSubscription: 'crud_offline_online.view',
      featureName: 'CRUD Offline/Online' 
    } 
  },
  {
    path: '/crud-online-only/',
    component: CrudOnlineOnly,
    meta: {
      requiresPermission: 'crud_online.view',
      requiresSubscription: 'crud_online.view',
      featureName: 'CRUD Online Only'
    }
  }
];
